// extracted by mini-css-extract-plugin
export var attribution = "_bg-4";
export var authorName = "_bg-5";
export var quote = "_bg-3";
export var testimonial = "_bg-2";
export var trustedBy = "_bg-0";
export var trustedByLabel = "_bg-1";